import { render, staticRenderFns } from "./ApplicationFlowDocumentPromptDownloader.vue?vue&type=template&id=08920907&scoped=true&"
import script from "./ApplicationFlowDocumentPromptDownloader.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowDocumentPromptDownloader.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowDocumentPromptDownloader.vue?vue&type=style&index=0&id=08920907&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08920907",
  null
  
)

export default component.exports